import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { ReserveSessionStatus } from "ipctg-inflow-types/InFlowEnums"

import api from "@/utilities/api"
import { matchesToRoutes } from "@/utilities/etc"
import { log } from "@/utilities/logging"
import welcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

export const Route = createFileRoute("/qr/$qrLookupID/reserve/$epoch")({
  beforeLoad: async ({ context, params, matches }) => {
    const isValidEpoch = welcomeTokenStorage.validateEpochFromUrl({
      epoch: params.epoch,
      flow: "reserve",
    })

    if (!isValidEpoch) {
      log({
        level: "warn",
        flow: "reserve",
        scope: "guard.epoch",
        message: "Invalid epoch, redirecting to /welcome",
      })
      throw redirect({ to: "/qr/$qrLookupID/welcome", params })
    }

    if (!context.isAuthenticated) {
      log({
        level: "warn",
        flow: "reserve",
        scope: "guard.auth",
        message: "User is unauthenticated, redirecting to /welcome",
      })
      throw redirect({ to: "/qr/$qrLookupID/welcome", params })
    }

    const sessionState = await api.reserve.sessionStatus.POST({})

    if (
      "status" in sessionState &&
      sessionState.status === ReserveSessionStatus.Complete &&
      !matchesToRoutes({
        matches,
        paths: [
          "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation",
          "/qr/$qrLookupID/reserve/$epoch/payment-complete",
        ],
      })
    ) {
      log({
        level: "warn",
        flow: "reserve",
        scope: "guard.sessionState",
        message: "Session status is complete, redirecting to payment-complete",
        meta: { sessionState },
      })
      throw redirect({
        to: "/qr/$qrLookupID/reserve/$epoch/payment-complete",
        params: { qrLookupID: params.qrLookupID, epoch: params.epoch },
      })
    }

    return { sessionState }
  },
  component: Outlet,
})
